import type { SearchBoxSuggestion } from "@mapbox/search-js-core";

export const searchBoxOptions = {
  types: "country,region,district,place,locality,neighborhood",
};

export interface LocationOption {
  label: string;
  value: string;
  description: string;
  originalSuggestion: SearchBoxSuggestion;
  suggestion: SearchBoxSuggestion;
}
